export async function getAdminSession() {
  const res = await fetch('/api/admin/session', { credentials: 'include' });
  if (!res.ok) {
    return { ok: false, role: null, email: null, name: null };
  }
  const data = await res.json().catch(() => ({}));
  return {
    ok: true,
    role: typeof data.role === 'string' ? data.role : 'admin',
    email: typeof data.email === 'string' ? data.email : null,
    name: typeof data.name === 'string' ? data.name : null,
  };
}

export async function fetchAdminSession() {
  return (await getAdminSession()).ok;
}

export async function adminLogout() {
  await fetch('/api/admin/logout', { method: 'POST', credentials: 'include' });
}
